module.exports = __webpack_public_path__ + "img/hina kagiyama_sc2.0e354df9.png";